import { useSelector, useDispatch } from 'react-redux';
import { useStatus, ERROR, SUCCESS, useLoading } from '@rootstrap/redux-tools';

import { getCelebrityWithSeriesId } from 'state/actions/celebritiesActions';
import { useCallback } from 'react';
import useSession from './useSession';

export default (id, seriesId) => {
  const { status } = useStatus(getCelebrityWithSeriesId);
  const dispatch = useDispatch();
  const {
    user: { id: currentUserId }
  } = useSession();

  const reset = () => {
    dispatch(getCelebrityWithSeriesId.reset());
  };

  const request = useCallback(
    (celebrityId, seriesId) => {
      const creatorId = celebrityId || id;
      dispatch(getCelebrityWithSeriesId(creatorId, seriesId));
    },
    [currentUserId, dispatch, id, seriesId]
  );

  return {
    celebrity: useSelector(({ celebrities: { celebrity } }) => celebrity),
    error: status === ERROR,
    refresh: (celebrityId, seriesId) => request(celebrityId, seriesId),
    success: status === SUCCESS,
    loading: useLoading(getCelebrityWithSeriesId),
    status,
    reset
  };
};
